import { render, staticRenderFns } from "./expreimburs.vue?vue&type=template&id=2e0e70a6"
import script from "./expreimburs.vue?vue&type=script&lang=js"
export * from "./expreimburs.vue?vue&type=script&lang=js"
import style0 from "./expreimburs.vue?vue&type=style&index=0&id=2e0e70a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports